/** Location type values accepted by `locations/manage`. */
export const LOCATION_TYPE_OPTIONS = [
  { label: 'Office', value: 'office' },
  { label: 'Remote', value: 'remote' },
  { label: 'Other', value: 'other' },
];

export const getLocationTypeLabel = (value) => {
  const match = LOCATION_TYPE_OPTIONS.find((option) => option.value === value);
  return match?.label || value || '—';
};
